import { render } from "./CDrawer.vue?vue&type=template&id=faeaaebe&scoped=true&ts=true"
import script from "./CDrawer.vue?vue&type=script&lang=ts"
export * from "./CDrawer.vue?vue&type=script&lang=ts"

import "./CDrawer.vue?vue&type=style&index=0&id=faeaaebe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faeaaebe"]])

export default __exports__